module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.show) ? _c('audio', {
    staticClass: "audioControls",
    attrs: {
      "controls": "controls",
      "preload": "none"
    }
  }, [_c('source', {
    attrs: {
      "src": _vm.src
    }
  })]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-fa2a7224","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/archives/AudioPlayer.vue
// module id = 481
// module chunks = 1